
import { useState,useEffect } from "react";
import Repo from "../Utility/Repo"



function Body(props) {

  const baseUrl = location.protocol + "//" + location.host;

  const [dataJson, setDataJson] = useState({});
  const [styleCard, setStyleCard] = useState(0);






  useEffect(() => {

    Repo.getConfigValue()
      .then(function (response) {
        setDataJson(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });

  }, []);



  const heroSetStyle = () => {
    let classString = "hero it-hero-wrapper"
    if (dataJson.hero.centered) {
      classString += " it-text-centered"
    }
    if (dataJson.hero.overlay) {
      classString += " it-" + dataJson.hero.overlay + " it-overlay"
    }
    return classString
  }


  const sectionSetStyle = (element) => {

    let classString = "section"
    if (element.background) {


      switch (element.background) {

        case "muted":
          classString += " section-muted"
          break;

        case "primary":
          classString += " section-primary"
          break;


        case "neutral":
          classString += " section-neutral"
          break;

        case "image":
          classString += " section-image"
          break;



      }

      console.log(element.background)

    }



    return classString
  }

  const calssButton = (element) => {

    let classString = "btn btn-"


    if (element.outlineButton) {
      classString += "outline-"
    }


    if (element.coloButton) {
      classString += element.coloButton
    }
    else {
      classString += "primary"
    }


    return classString;


  }



  const getBackground = (x) => {

    return "url(" + baseUrl + "/image/" + x + ")"
  }



  return <div >

    {(dataJson.hero) &&
      <div className={"customHero"} style={{ backgroundImage: getBackground(dataJson.hero.img).toString() }}>

        <div className=" text-center align-middle customHeroOverlay">
          
          <h3 className=" text-white"><i>Benvenuti nel portale, realizzato per cittadini, imprese e P.A. <br />Garantisce Sicurezza, Usabilità e Trasparenza</i></h3>
          <div className="mt-5">
            <h6 className=" text-white"><i>"{dataJson.hero.grommet}"</i></h6>
          </div>
        </div>

        <div className="container">

        </div>

      </div>

    }


    {dataJson.cardArea

      && dataJson.cardArea.map((cardArea, index) =>

        <div className="section  container" key={index}>
          <div className="section-content">


            <div className="card-deck ">

              {cardArea && cardArea.listCard.map((x, i) =>


                <div className="card card-teaser  mg-md-4  rounded hoverCard" key={i} style={
                  { background: x.background, border: "1px solid " + x.borderColor, minHeight :"237px" }}



                ><a href={x.link} className="text-decoration-none">
                    <div className="card-body row">
                      <div className="col-lg-3 text-center py-2s">
                        <img src={baseUrl + "/image/" + x.img} style={{ height: "80px" }} />
                      </div>
                      <div className="col-lg-9">
                        <div className="row"><h3 className={"text-" + x.colorTitle}>{x.title}</h3></div>
                        <div className={"row text-" + x.colorDesc}>
                          {x.desc}
                        </div>
                      </div>

                    </div></a>
                </div>)}




            </div>

          </div>
        </div>


      )}




  </div>






}

export default Body;

